'use client';
import { useRouter } from 'next/navigation';

import getAPI from '@graphql/getAPI';
import { Link } from '@heroui/link';
import { FormFieldHelpers, ZodForm } from '@rachelallyson/hero-hook-form';
import { capture, EventType } from '@Soultrics/_utils/events';
import { z } from 'zod';

const signUpSchema = z.object({
  email: z
    .string()
    .email('Must be a valid email address')
    .min(1, 'Email is required'),
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  password: z.string().min(8, 'Password must be at least 8 characters'),
  title: z.string().optional(),
});

type SignUpFormData = z.infer<typeof signUpSchema>;

function SignUp() {
  const router = useRouter();

  return (
    <>
      <div className="flex items-center">
        <div className="grid p-4 gap-4 items-center w-full">
          <ZodForm<SignUpFormData>
            config={{
              defaultValues: {
                email: '',
                firstName: '',
                lastName: '',
                password: '',
                title: '',
              },
              fields: [
                FormFieldHelpers.content('Sign Up', undefined),
                FormFieldHelpers.input('firstName', 'First Name'),
                FormFieldHelpers.input('lastName', 'Last Name'),
                FormFieldHelpers.input('title', 'Church Role'),
                FormFieldHelpers.input('email', 'Email', 'email'),
                FormFieldHelpers.input('password', 'Password', 'password'),
              ],
              schema: signUpSchema,
            }}
            submitButtonText="Join"
            onSubmit={async (info: SignUpFormData) => {
              const api = getAPI();

              await api.signup({ data: info }, { revalidate: ['me'] });
              capture(EventType.NEW_SIGN_UP);
            }}
            onSuccess={() => {
              // Redirect to admin dashboards after successful signup
              router.push('/admin/dashboards');
              router.refresh();
            }}
          />
          <div className="grid grid-cols-2">
            <p>
              Already Have an Account?&nbsp;
              <Link href="/login">Log In</Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default SignUp;
